import React, { useCallback } from 'react';
import { withTranslation } from 'react-i18next';

import { copyToClipboard } from 'utils/index';

import Tooltip from 'components/tooltip';

const TaskNiceId = ({ niceId, t }) => {
    const hanldeClick = useCallback(() => {
        copyToClipboard(niceId);
    }, [niceId]);

    return (
        <Tooltip tooltip={ t('Reference this task in discussions and messages') } placement="top">
            <span className="nice-id" onClick={hanldeClick}>{ niceId }</span>
        </Tooltip>
    );
}

export default withTranslation('task')(TaskNiceId);
